import React, { useState } from 'react';
import CalendarPanel from './CalendarPanel';
import Reports from './Reports';
import Chores from './Chores';
import MealPanel from './MealPanel';
import GroceryPanel from './GroceryPanel';
import PetTracker from './PetTracker';
import QuickAddPanel from './QuickAddPanel';

const TABS = [
  { id: 'calendar', label: 'Today',   icon: '📅' },
  { id: 'meals',    label: 'Meals',   icon: '🍽️' },
  { id: 'grocery',  label: 'Grocery', icon: '🛒' },
  { id: 'pets',     label: 'Pets',    icon: '🐾' },
  { id: 'chores',   label: 'Chores',  icon: '🧹' },
  { id: 'reports',  label: 'Reports', icon: '📊' },
];

export default function MobileLayout({ groceryRef }) {
  const [active, setActive] = useState('calendar');

  return (
    <div style={styles.root}>
      <div style={styles.content}>
        {active === 'calendar' && <CalendarPanel />}
        {active === 'meals'    && <MealPanel />}
        {active === 'grocery'  && (
          <div style={styles.groceryWrap}>
            <QuickAddPanel onItemAdded={() => groceryRef?.current?.reload()} />
            <div style={styles.groceryList}>
              <GroceryPanel ref={groceryRef} />
            </div>
          </div>
        )}
        {active === 'pets'     && <PetTracker />}
        {active === 'chores'   && <Chores />}
        {active === 'reports'  && <Reports />}
      </div>

      <nav style={styles.tabBar}>
        {TABS.map(tab => (
          <button
            key={tab.id}
            style={{
              ...styles.tab,
              ...(active === tab.id ? styles.tabActive : {}),
            }}
            onClick={() => setActive(tab.id)}
          >
            <span style={styles.tabIcon}>{tab.icon}</span>
            <span style={{
              ...styles.tabLabel,
              ...(active === tab.id ? styles.tabLabelActive : {}),
            }}>
              {tab.label}
            </span>
            {active === tab.id && <span style={styles.tabIndicator} />}
          </button>
        ))}
      </nav>
    </div>
  );
}

const styles = {
  root: {
    display: 'flex',
    flexDirection: 'column',
    height: '100%',
    overflow: 'hidden',
  },
  content: {
    flex: 1,
    overflow: 'hidden',
    padding: '16px 16px 0',
    display: 'flex',
    flexDirection: 'column',
  },
  groceryWrap: {
    display: 'flex',
    flexDirection: 'column',
    gap: 12,
    height: '100%',
    overflow: 'hidden',
  },
  groceryList: {
    flex: 1,
    overflow: 'hidden',
    display: 'flex',
    flexDirection: 'column',
  },
  tabBar: {
    display: 'flex',
    borderTop: '1px solid var(--border)',
    background: 'var(--surface)',
    flexShrink: 0,
    paddingBottom: 'env(safe-area-inset-bottom)',
  },
  tab: {
    flex: 1,
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    gap: 3,
    padding: '10px 0 8px',
    background: 'none',
    border: 'none',
    cursor: 'pointer',
    position: 'relative',
    WebkitTapHighlightColor: 'transparent',
  },
  tabActive: {
    background: 'rgba(232,201,122,0.05)',
  },
  tabIcon: {
    fontSize: '1.3rem',
    lineHeight: 1,
  },
  tabLabel: {
    fontFamily: 'var(--font-mono)',
    fontSize: '0.6rem',
    letterSpacing: '0.1em',
    textTransform: 'uppercase',
    color: 'var(--text-dimmer)',
  },
  tabLabelActive: {
    color: 'var(--accent)',
  },
  tabIndicator: {
    position: 'absolute',
    top: 0,
    left: '25%',
    right: '25%',
    height: 2,
    background: 'var(--accent)',
    borderRadius: '0 0 2px 2px',
  },
};
